import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ReportService } from '../../services/report.service';
import { actionIdConstants } from 'src/app/common/constants/common.contants';
import { UserService } from 'src/app/common/services/user.service';
import { ActivatedRoute } from '@angular/router';
import { activityPayload } from 'src/app/common/models/userActivity.model';
@Component({
  selector: 'app-download-property-report',
  templateUrl: './download-property-report.component.html',
  styleUrls: ['./download-property-report.component.scss']
})
export class DownloadPropertyReportComponent {

  isExpand : boolean = true
  propertyReportData :any[] = [];
  propertyReportDataOption : any[] = [
    {
      name : "reports.parcel_data",
      display : false,
      isAccordion : false,
      isDisable : true,
    },
    {
      name : "reports.nearby_transaction_data",
      display : false,
      isAccordion : false,
      isDisable : true,
    },
    {
      name : "reports.nearby_Rental_Data",
      display : false,
      isAccordion : false,
      isDisable : false,
    },
  ];
  nearby_Rental_Data : any[] = []
  nearby_Rental_Data_orginal: any[] = [
    {
      name : "reports.residential_properties",
      display : false,
      propertyCategory : 'multi_story_residential'
    },
    {
      name : "reports.retail_properties",
      display : false,
      propertyCategory : 'retail_f_b_and_entertainment'
    },
    {
      name : "reports.office_properties",
      display : false,
      propertyCategory : 'multi_story_office'
    },
    {
      name : "reports.Warehouse_properties",
      display : false,
      propertyCategory : 'industry_workshop_warehouse'
    }
  ]
  loader: boolean=false;
  reportId: number = 0;

  constructor(public dialogRef : MatDialogRef<DownloadPropertyReportComponent>,
    @Inject(MAT_DIALOG_DATA) public info: any,
    private reportService: ReportService,
    private userService: UserService,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    this.getPdfDownloadOption();
    this.reportId = this.activatedRoute.snapshot.queryParams['rid'];
  }

  getPdfDownloadOption() {
    this.loader=true;
    this.reportService.getOptions(this.info.param, this.info.Property_Uid).subscribe({
      next: (res:any)=>{
        this.loader=false;
        if (res.status == 200) {
          let data = res.data;
          this.nearby_Rental_Data_orginal.forEach((element: any) => {
            if (data[element.propertyCategory]) {
              element.display = true;
              this.nearby_Rental_Data.push(element)
            }
          })
          if (this.nearby_Rental_Data.length != 0) {
            this.propertyReportDataOption[2].display = true;
            this.propertyReportDataOption[2].isAccordion = true;
            this.propertyReportData = this.propertyReportDataOption.slice(0, this.propertyReportDataOption.length);
          } else {
            this.propertyReportData = this.propertyReportDataOption.slice(0, this.propertyReportDataOption.length - 1);
          }
        } else {
          this.propertyReportData = this.propertyReportDataOption.slice(0, this.propertyReportDataOption.length - 1);
        }
      },
      error:()=>{
        this.loader=false;
        this.propertyReportData = this.propertyReportDataOption.slice(0,this.propertyReportDataOption.length - 1);
      }
    })
  }



  selectAllReport(propertyReport:any) {
    if(propertyReport.name == 'reports.parcel_data' || propertyReport.name == 'reports.nearby_transaction_data') return
    propertyReport.display = !propertyReport.display;
    this.nearby_Rental_Data.forEach((data:any) => {
      data.display = propertyReport.display
    })
  }
  selectedReport(rentalData: any) {
    rentalData.display = !rentalData.display;
    let isAllSelected = this.nearby_Rental_Data.every((data) => data.display);
    if(isAllSelected) {
      this.propertyReportData[2].display = true;
    }else {
      this.propertyReportData[2].display = false;
    }
  }


  expandAccordion(propertyReport:any) {
    if(propertyReport.name == 'reports.parcel_data' || propertyReport.name == 'reports.nearby_transaction_data') return
    this.isExpand = !this.isExpand
  }

  downloadProperty() {
    let data = ""
    this.nearby_Rental_Data.forEach((rentalData:any) => {
      if(rentalData.display) {
        data = !data ? rentalData.propertyCategory : [data,rentalData.propertyCategory].join(',');
      }
    })
      this.dialogRef.close(data ? data : 'default');
  }

  closePopUp() {
    this.dialogRef.close("close");
  }
}
